/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A workflow and current status option used by accessible cross-company shared claims.
 * @export
 * @interface ClaimSharedFilterOption
 */
export interface ClaimSharedFilterOption {
    /**
     * 
     * @type {string}
     * @memberof ClaimSharedFilterOption
     */
    companyName: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimSharedFilterOption
     */
    pipelineId: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimSharedFilterOption
     */
    pipelineName: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimSharedFilterOption
     */
    pipelineColor: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimSharedFilterOption
     */
    statusTemplateId: number | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimSharedFilterOption
     */
    statusName: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimSharedFilterOption
     */
    statusColor: string | null;
}

/**
 * Check if a given object implements the ClaimSharedFilterOption interface.
 */
export function instanceOfClaimSharedFilterOption(value: object): value is ClaimSharedFilterOption {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('pipelineId' in value) || value['pipelineId'] === undefined) return false;
    if (!('pipelineName' in value) || value['pipelineName'] === undefined) return false;
    if (!('pipelineColor' in value) || value['pipelineColor'] === undefined) return false;
    if (!('statusTemplateId' in value) || value['statusTemplateId'] === undefined) return false;
    if (!('statusName' in value) || value['statusName'] === undefined) return false;
    if (!('statusColor' in value) || value['statusColor'] === undefined) return false;
    return true;
}

export function ClaimSharedFilterOptionFromJSON(json: any): ClaimSharedFilterOption {
    return ClaimSharedFilterOptionFromJSONTyped(json, false);
}

export function ClaimSharedFilterOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimSharedFilterOption {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'pipelineId': json['pipelineId'],
        'pipelineName': json['pipelineName'],
        'pipelineColor': json['pipelineColor'],
        'statusTemplateId': json['statusTemplateId'],
        'statusName': json['statusName'],
        'statusColor': json['statusColor'],
    };
}

export function ClaimSharedFilterOptionToJSON(json: any): ClaimSharedFilterOption {
    return ClaimSharedFilterOptionToJSONTyped(json, false);
}

export function ClaimSharedFilterOptionToJSONTyped(value?: ClaimSharedFilterOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'pipelineId': value['pipelineId'],
        'pipelineName': value['pipelineName'],
        'pipelineColor': value['pipelineColor'],
        'statusTemplateId': value['statusTemplateId'],
        'statusName': value['statusName'],
        'statusColor': value['statusColor'],
    };
}

